import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import Editor from './Editor';

export default function Dialogue({ itemCount = 3 }) {
    return createTaskType({
        id: 'dialogue',
        label: 'Dialogue',
        skill: 'listening',
        v2: true,
        hasRubric: true,

        editor: Editor,
        createItemsTemplate: () => times(itemCount + 1, index => ({
            is_example: index === 0,
            ...(index === 0 && { rubric_id: '' }),

            answers: times(3, () => ({
                audio_id: '',
                is_correct_answer: false,
            })),
        })),

        backgroundImages: { count: 2 },

        convertToLocalFormat(task) {
            // QYL-8068: Reduce items to 4 (from 5) + example
            task.items = task.items.splice(0, 5);
            return task;
        },

        convertToUploadFormat(task, { isNew }) {
            task = cloneDeep(task);

            // Dialogue does not use these fields, they are not allowed by the backend.
            delete task?.colors;
            delete task?.final_audio_id;

            return task;
        },

        getKeys: (item) => {
            const audio = item.answers.find(x => x.is_correct_answer)?.audio_id;
            if (!audio) return [];

            const transcript = !!audio.transcript ? ` (${audio.transcript})` : '';
            return item.answers
                .filter(x => x.is_correct_answer)
                .map(x => `Option ${'ABC'[x.order - 1]} - ${x.audio_id} ${transcript}`);
        }
    })
};